module.exports = __webpack_public_path__ + "img/caizhao.3f2696d0.png";